/**
 * 事業内容ページ — 企画・施工カテゴリ。
 * PC/タブレット: 3カラムのタブ（クリック/キーボードで切替）。
 * SP: 無限カルーセル（手スワイプ主体・前/次矢印・自動再生なし）。
 *   先頭/末尾に1枚ずつクローンを置き、クローンへ乗ったら実カードへ瞬間ジャンプして無限ループ。
 */
(function () {
  'use strict';

  var tablist = document.querySelector('.svc-cats__tablist[role="tablist"]');
  if (!tablist) {
    return;
  }

  var realCards = Array.prototype.slice.call(tablist.querySelectorAll('[data-services-tab]'));
  if (!realCards.length) {
    return;
  }

  var mqSP = window.matchMedia('(max-width: 768px)');

  function panelFor(card) {
    return document.querySelector('[data-services-panel="' + card.getAttribute('data-services-tab') + '"]');
  }

  // --- 無限ループ用クローン（末尾を先頭へ、先頭を末尾へ） ---
  var lastClone = realCards[realCards.length - 1].cloneNode(true);
  var firstClone = realCards[0].cloneNode(true);
  [lastClone, firstClone].forEach(function (c) {
    c.removeAttribute('id');
    c.removeAttribute('role');
    c.setAttribute('aria-hidden', 'true');
    c.setAttribute('tabindex', '-1');
    c.classList.add('svc-cat-tab--clone');
  });
  tablist.insertBefore(lastClone, realCards[0]);
  tablist.appendChild(firstClone);
  var allCards = [lastClone].concat(realCards, [firstClone]);

  // --- 選択（中央カードをアクティブ表示＋詳細パネル切替） ---
  function selectCard(card, setFocus) {
    var cat = card.getAttribute('data-services-tab');
    allCards.forEach(function (c) {
      c.classList.toggle('is-active', c === card);
    });
    realCards.forEach(function (t) {
      var sel = t.getAttribute('data-services-tab') === cat;
      t.setAttribute('aria-selected', sel ? 'true' : 'false');
      t.setAttribute('tabindex', sel ? '0' : '-1');
      var panel = panelFor(t);
      if (panel) {
        if (sel) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }
    });
    if (setFocus && card.focus) {
      card.focus();
    }
  }

  // --- カルーセル: 中央寄せ / 中央に最も近いカード ---
  function centerCard(card, smooth) {
    var listRect = tablist.getBoundingClientRect();
    var cardRect = card.getBoundingClientRect();
    var target = (cardRect.left - listRect.left) + tablist.scrollLeft + cardRect.width / 2 - tablist.clientWidth / 2;
    tablist.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
  }
  function nearestCard() {
    var listRect = tablist.getBoundingClientRect();
    var center = listRect.left + listRect.width / 2;
    var best = allCards[0];
    var bestD = Infinity;
    allCards.forEach(function (card) {
      var r = card.getBoundingClientRect();
      var d = Math.abs(r.left + r.width / 2 - center);
      if (d < bestD) {
        bestD = d;
        best = card;
      }
    });
    return best;
  }

  // --- スクロール停止 → 中央カードをアクティブ化＋クローンなら実カードへ瞬間ジャンプ ---
  var scrollTimer = null;
  tablist.addEventListener('scroll', function () {
    if (!mqSP.matches) {
      return;
    }
    if (scrollTimer) {
      clearTimeout(scrollTimer);
    }
    scrollTimer = setTimeout(function () {
      var card = nearestCard();
      selectCard(card, false);
      if (card === lastClone) {
        centerCard(realCards[realCards.length - 1], false);
      } else if (card === firstClone) {
        centerCard(realCards[0], false);
      }
    }, 100);
  }, { passive: true });

  // --- 前/次矢印（無限・自動再生なし） ---
  function go(delta) {
    var idx = allCards.indexOf(nearestCard());
    var t = Math.max(0, Math.min(allCards.length - 1, idx + delta));
    centerCard(allCards[t], true);
  }
  var prevBtn = document.querySelector('[data-services-prev]');
  var nextBtn = document.querySelector('[data-services-next]');
  if (prevBtn) {
    prevBtn.addEventListener('click', function () { go(-1); });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function () { go(1); });
  }

  // --- カードクリック（実/クローン共通） ---
  allCards.forEach(function (card) {
    card.addEventListener('click', function () {
      if (mqSP.matches) {
        centerCard(card, true);   // スクロール停止時に selectCard される
      } else {
        selectCard(card, false);
      }
    });
  });

  // --- キーボード（PC タブ） ---
  realCards.forEach(function (tab, index) {
    tab.addEventListener('keydown', function (e) {
      var n = null;
      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          n = (index + 1) % realCards.length;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          n = (index - 1 + realCards.length) % realCards.length;
          break;
        case 'Home':
          n = 0;
          break;
        case 'End':
          n = realCards.length - 1;
          break;
        default:
          return;
      }
      e.preventDefault();
      selectCard(realCards[n], true);
      if (mqSP.matches) {
        centerCard(realCards[n], true);
      }
    });
  });

  // --- 初期化：アクティブを正規化（クローンの is-active を消す）。SP は先頭を中央へ。 ---
  function init() {
    selectCard(realCards[0], false);
    if (mqSP.matches) {
      centerCard(realCards[0], false);
    }
  }
  requestAnimationFrame(init);
  if (mqSP.addEventListener) {
    mqSP.addEventListener('change', function (e) { if (e.matches) { requestAnimationFrame(init); } });
  } else if (mqSP.addListener) {
    mqSP.addListener(function (e) { if (e.matches) { requestAnimationFrame(init); } });
  }
})();
